 const Error = () => {
    return (
        <div>
            <h1>Oops ! Something went wrong</h1>
            <p>Sorry, the page you are looking for does not exist.</p>
        </div>
    )
}

export default Error;